<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { store } from '@/store'
import type { FormInstance, FormRules } from 'element-plus'
import { getOrgInfo } from "@/api/system"
import { useRouter } from 'vue-router'
import router from '@/router';
import { useVueCesium } from 'vue-cesium'
import type { VcViewerProvider, VcReadyObject } from 'vue-cesium/es/utils/types'
import { flyToCamera } from 'vue-cesium/es/utils/cesium-helpers'

const $vc: VcViewerProvider = useVueCesium()

const $router = useRouter()

const loginLoading = ref(false)

const loginFormRef = ref<FormInstance>()

interface LoginForm {
  username?: string
  password?: string
  flag: number
}

const rules = reactive<FormRules<LoginForm>>({
  username: [
    { required: true, message: '请输入正确的用户名', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入正确的密码', trigger: 'blur' },
  ],
})

const loginForm = reactive<LoginForm>({
  username: '',
  password: '',
  flag: 1
})


const onSubmit = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      loginLoading.value = true
      store.system
        .useAccountStore()
        .login(loginForm)
        .then(() => {
          // 重定向对象不存在则返回顶层路径
          $router.replace(($router.currentRoute.value.query.redirect as string) || "/flightList")
        }).catch((e) => {
          loginLoading.value = false
        })
    } else {
      console.log('error submit!', fields)
    }
  })
}

function GetQueryString(name: any) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
  let context = '';
  if (r) context = r[2];
  return context ? context : '';
}

async function getToken() {
  if (GetQueryString("tk")) {
    // console.log(GetQueryString("tk"))
    sessionStorage.setItem("token", GetQueryString("tk"))
    sessionStorage.setItem("key", GetQueryString("key"))
    sessionStorage.setItem("type", GetQueryString("type"))
    const userdetails = await getOrgInfo({})
    if (userdetails.list[0].cityCode) {
      localStorage.setItem("cityCode", userdetails.list[0].cityCode);
    }
    if (userdetails.list[0].areaCode) {
      localStorage.setItem("areaCode", userdetails.list[0].areaCode)
    }
    if (userdetails.list[0].areaCode) {
      localStorage.setItem("provinceCode", userdetails.list[0].id)
    }
    if (userdetails.list[0].lng) {
      localStorage.setItem("lng", userdetails.list[0].lng);
      localStorage.setItem("lat", userdetails.list[0].lat);
    }
    if (userdetails.list[0].alt) {
      localStorage.setItem("alt", userdetails.list[0].alt);
    }

    if (GetQueryString("device_sn")) {
      router.push({
        path: "/monitor",
        query: {
          deviceSn: GetQueryString("device_sn"),
          domain: 3
        }
      })
      flyToCamera(
        $vc.viewer,
        {
          position: Cesium.Cartesian3.fromDegrees(Number(localStorage.getItem("lng")) - 0.0005, Number(localStorage.getItem("lat"))  - 0.083, 5000),
          heading: 6.283185307179586,
          pitch: -0.5001412827126326,
          roll: 6.283185307179586
        },
      )
      return
    }
    $router.replace(($router.currentRoute.value.query.redirect as string) || "/flightList")
  }
}


onMounted(() => {
  store.informationListStore.informationStore().setTreatActive(false)
  getToken()
})

</script>

<template>
  <div class="login-box">
    <div class="login-right">
      <div class="login-title">数智港航</div>
      <el-form style="max-width:450px" :model="loginForm" label-width="auto" size="large" class="loginForm"
        :rules="rules" ref="loginFormRef">
        <el-form-item class="formItem" prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item class="formItem formPass" prop="password">
          <el-input v-model="loginForm.password" placeholder="请输入登录密码" type="password" show-password />
        </el-form-item>
        <el-form-item class="formItem">
          <el-button type="primary" class="loginBtn" @click="onSubmit(loginFormRef)"
            :loading="loginLoading">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<style scoped lang="scss">
.login-box {
  width: 100vw;
  height: 100vh;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url("@/assets/images/login-bj.png");

  .login-right {
    width: 29.1vw;
    height: 456px;
    // padding: 16px 70px;
    border-radius: 20px;
    z-index: 1;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("@/assets/images/login-ipt.png");

    .login-title {
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 26px;
      color: #C8E7FF;
      line-height: 0px;
      text-align: center;
      font-style: normal;
      margin-top: 55px;
    }

    .imgBox {
      width: 16rem;
      height: 256px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .word {
      text-align: center;
      color: rgb(136, 136, 136);
      font-size: 1.25rem;
      font-weight: 500;
      line-height: 2rem;
      letter-spacing: 0.0125em;
    }

    .loginForm {
      margin: 0 auto;
      margin-top: 90px;

      .formItem {
        width: 21.7vw;
        margin: 1.875rem auto;
        background-color: unset !important;
        background-image: url('@/assets/images/ipt-bj.png');
        /* 替换为你的图片路径 */
        background-size: 100% 100%;
        /* 背景图片覆盖整个input区域 */
        background-repeat: no-repeat;
        /* 背景图片不重复 */
        background-position: center;

        /* 背景图片居中 */
        :deep(.el-input__wrapper) {
          background-color: transparent;
          box-shadow: none;
        }

        :deep(.el-input__inner) {
          height: 51px;
          background-size: 20px 21px;
          background: url("@/assets/images/user-pic.png") no-repeat;
          background-position: 0px 13px;
          text-indent: 30px;
          color: #fff;

          &:-webkit-autofill {
            box-shadow: 0 0 0 1000px transparent inset !important;
            -webkit-text-fill-color: #fff !important;
          }

          // 设置输入框自动填充的延迟属性
          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus,
          &:-webkit-autofill:active {
            transition: color 99999s ease-out, background-color 99999s ease-out;
            transition-delay: 99999s;
          }
        }
      }

      .formPass {
        :deep(.el-input__inner) {
          height: 51px;
          background-size: 20px 21px;
          background: url("@/assets/images/pass-pic.png") no-repeat;
          background-position: 0px 13px;
          text-indent: 30px;
          color: #fff;
        }
      }

      .loginBtn {
        width: 100%;
        height: 51px;
        background-image: url('@/assets/images/login-btn.png');
        /* 替换为你的图片路径 */
        background-size: 100% 100%;
        /* 背景图片覆盖整个input区域 */
        background-repeat: no-repeat;
        /* 背景图片不重复 */
      }
    }
  }
}
</style>
